/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { validateName } from 'src/onboarding/helpers/validateName';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import getLocale from 'src/localization/get-locale';

function capitalizeName(name) {
  if (!name.trim()) return '';
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

function Page() {
  const name = useStore((state) => state.name);
  const setName = useStore((state) => state.setName);
  const { onNext, onPrev, currentIndex } = useNav();

  const [errorMessage, setErrorMessage] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  const isIOS = () => {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  };

  useEffect(() => {
    const preventScroll = (event) => {
      event.preventDefault();
    };

    document.body.addEventListener('touchmove', preventScroll, { passive: false });

    return () => {
      document.body.removeEventListener('touchmove', preventScroll);
    };
  }, []);

  useEffect(() => {
    const input = document.getElementById('name-field');

    let resizeTimeout: number | null = null;

    const updateButtonPosition = () => {
      if (!window.visualViewport || !isIOS()) return;
      const keyboardHeight = window.innerHeight - window.visualViewport.height;
      const buttonElement = document.querySelector('.next-wrapper') as HTMLElement;
      const buttonBg = document.querySelector('.button-white-bg') as HTMLElement;

      if (keyboardHeight > 100) {
        if (buttonElement) buttonElement.style.bottom = `${keyboardHeight}px`;
        if (buttonBg) buttonBg.style.bottom = `${keyboardHeight}px`;
      } else {
        if (buttonElement) buttonElement.style.bottom = '0px';
        if (buttonBg) buttonBg.style.bottom = '0px';
      }
    };

    const onFocus = () => {
      setKeyboardOpen(true);
      updateButtonPosition();

      requestAnimationFrame(() => {
        setTimeout(updateButtonPosition, 200);
      });
    };

    const onBlur = () => {
      if (!isIOS()) return;

      setKeyboardOpen(false);
      const buttonElement = document.querySelector('.next-wrapper') as HTMLElement;
      const buttonBg = document.querySelector('.button-white-bg') as HTMLElement;
      if (buttonElement) buttonElement.style.bottom = '0px';
      if (buttonBg) buttonBg.style.bottom = '0px';
    };

    const onResize = () => {
      if (resizeTimeout) window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(() => {
        updateButtonPosition();
      }, 50);
    };

    if (input) {
      input.addEventListener('focus', onFocus);
      input.addEventListener('blur', onBlur);
    }
    window.visualViewport?.addEventListener('resize', onResize);

    return () => {
      if (input) {
        input.removeEventListener('focus', onFocus);
        input.removeEventListener('blur', onBlur);
      }
      window.visualViewport?.removeEventListener('resize', onResize);
    };
  }, []);

  useEffect(() => {
    const validationResult = validateName(name);
    setErrorMessage(validationResult.errorMessage);
    setIsValid(validationResult.isValid);
  }, [name]);

  const handleInputChange = (event) => {
    const formattedName = capitalizeName(event.target.value);
    setName(formattedName);
  };

  const locale = getLocale();

  const getPaddingLeft = (name: string | undefined, locale: string): number => {
    if (name?.length >= 1) return 0;

    switch (locale) {
      case 'en':
        return 80;
      // case 'tr': return 90;
      // case 'fr': return 75;
      // case 'cs': return 60;
      // case 'de':
      // case 'id':
      // case 'it':
      // case 'pt': return 55;
      // case 'es':  return 40;
      default:
        return 80;
    }
  };
  return (
    <div className='page'>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className='wrapper-info'>
        <Title tag='h2'>{t('onboarding.name.title_new')}</Title>
        <Text size='m' medium className='description'>
          {t('onboarding.name.subTitle')}
        </Text>
      </div>

      <div className='controls'>
        <input
          id='name-field'
          type='text'
          value={name}
          placeholder={t('onboarding.name.inputPlaceholder')}
          onChange={handleInputChange}
          autoFocus
          style={{
            textAlign: (name?.length || 0) >= 1 ? 'center' : 'left',
            caretColor: 'black',
            paddingLeft: getPaddingLeft(name, locale),
          }}
        />
        <div className='line'></div>
        {errorMessage && (
          <Caption size='m' className='error-message' style={{ margin: 0 }}>
            {errorMessage}
          </Caption>
        )}
      </div>
      <div className={`button-white-bg ${keyboardOpen && isIOS() ? 'keyboard-open' : ''}`}></div>
      <div>
        <div className={`next-wrapper ${keyboardOpen && isIOS() ? 'keyboard-open' : ''}`}>
          <Button
            className={!isValid && 'disabled'}
            title={t('onboarding.name.continue')}
            onClick={() => {
              if (!isValid) return;
              Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
                page: 'name',
                answer: name,
              });
              onNext();
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Page;
